import { useForm } from "react-hook-form"

import { ActionButton } from "components/Button"
import { ErrorMessage, Input } from "components/forms/FormElements"
import FormTemplate from "components/forms/FormTemplate"

const ContactForm: React.FC = () => {
  const rhf = useForm()

  return (
    <FormTemplate rhf={rhf} formName="Contact form">
      <div className="grid smmax:grid-cols-1 mdmin:grid-cols-2 mdmin:gap-2">
        <div>
          <Input
            type="text"
            showRequired
            {...rhf.register("name", { required: true })}
          />
          {rhf.formState.errors.name && (
            <ErrorMessage>Please enter your name</ErrorMessage>
          )}
        </div>

        <div>
          <Input
            type="text"
            showRequired
            {...rhf.register("postcode", { required: true })}
          />
          {rhf.formState.errors.postcode && (
            <ErrorMessage>Please enter your postcode</ErrorMessage>
          )}
        </div>
      </div>

      <div className="grid smmax:grid-cols-1 mdmin:grid-cols-2 mdmin:gap-2">
        <div>
          <Input
            placeholder="Telephone number"
            type="tel"
            showRequired
            {...rhf.register("telephoneNumber", { required: true })}
          />
          {rhf.formState.errors.telephoneNumber && (
            <ErrorMessage>Please enter your telephone number</ErrorMessage>
          )}
        </div>

        <div>
          <Input
            customLabel="Email address"
            type="email"
            {...rhf.register("emailAddress")}
          />
        </div>
      </div>

      <div>
        <Input
          as="textarea"
          placeholder="Please tell us what your requirements are"
          rows={3}
          showRequired
          {...rhf.register("message", { required: true })}
        />
        {rhf.formState.errors.message && (
          <ErrorMessage>Please tell us what your requirements are</ErrorMessage>
        )}
      </div>

      <ActionButton kind="submit" isLoading={rhf.formState.isSubmitting}>
        Send message
      </ActionButton>
    </FormTemplate>
  )
}

export default ContactForm
